import {apiRequest} from 'util/api/util'

export const sendNewError = async (message) => {

  try {
    await fetch("https://hooks.slack.com/services/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", {
      method: "POST",
      body: JSON.stringify({
        text: message
      })
    })  
    return
  } catch (err) {
    return
  }
}
